import { Request } from 'common/domain/models/request';

class PeriodCardIconController {
  constructor() {
  }

  isRequested() {
    return this.status === Request.STATUS.REQUESTED || this.status === Request.STATUS.DELETED;
  }

  isApproved() {
    return this.status === Request.STATUS.APPROVED;
  }

}

export default PeriodCardIconController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodCard/periodCardIcon/periodCardIcon.controller.js